import { connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { selectIsFavourite, updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectShowFeaturedProduct } from 'src/redux/products/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import type { NextConfig } from 'src/types/nextConfig';
import { getProductImpressionsTrackingEvent } from '../../../../tracking/events/productImpression';
import { getImpressionFieldObject } from '../../../../utils';
import { FeaturedProduct } from '../components/FeaturedProduct';

const nextConfig = getConfig() as NextConfig;

const mapStateToProps = (state: ReduxApplicationState) => ({
  currency: state.products.currencyCode,
  product: state.products.featuredProduct,
  onComponentVisible: () => {
    const { items, productsReturnedCount, searchTerm, category, featuredProduct } = state.products;
    const { pageType } = state.navigation;
    const product = featuredProduct!;

    sendGAEvent({ ecommerce: null });

    const trackingEvent = getProductImpressionsTrackingEvent({
      eventCategory: 'Featured Product',
      eventAction: 'Product Impressions',
      eventLabel: 'not set',
      impressions: [
        getImpressionFieldObject(
          product,
          items,
          productsReturnedCount,
          category,
          searchTerm,
          pageType,
          {
            positionOverride: 1,
            listSuffix: ' - featured product',
          },
        ),
      ],
    });

    sendGAEvent(trackingEvent);
  },
  onProductOutOfStock: () => {
    const { featuredProduct } = state.products;

    if (featuredProduct?.inventoryStatus === 'out_of_stock') {
      sendGAEvent({
        event: 'custom_event',
        event_category: 'Featured Product',
        event_action: 'Out of stock',
        event_label: String(featuredProduct.code),
      });
    }
  },
  visible: selectShowFeaturedProduct(state),
  isFavorite: state.products.featuredProduct
    ? selectIsFavourite(state.favourites.summary, state.products.featuredProduct.code)
    : false,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onUpdateFavorite: (productCode: number) => dispatch(updateFavourite({ productCode, nextConfig })),
});

export const FeaturedProductContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FeaturedProduct);
